import { toast } from "react-toastify";

import Plants from "../../../api/plants";

export const plants = {
  state: {
    plants: [],
    loading: false,
  },
  reducers: {
    setPlants(state, payload) {
      return {
        ...state,
        plants: payload,
      };
    },
    loading(state, payload) {
      return {
        ...state,
        loading: payload.loading,
      };
    },
    clearStore() {
      return {};
    },
    setError(state, payload) {
      return {
        ...state,
        error: {
          message: payload.message,
          data: payload.data
        }
      }
    },
    setClearPlantErrors(state, payload) {
      return {
        ...state,
        error: payload
      }
    }
  },
  effects: (dispatch) => ({
    async loadAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        let data = [];
        const res = await Plants.listByBranch(payload);
        data = res.data;
        this.setPlants(data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async loadAvailableAsync(payload, rootState) {
      const { idProduct, idBranch, idLoadType } = payload;
      try {
        this.loading({ loading: true });
        let data = [];
        if (idProduct && idBranch) {
          const res = await Plants.listAvailableByBranchAndProduct(
            idProduct,
            idBranch,
            idLoadType
          );
          data = res.data;
        }
        this.setPlants(data);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        toast.error("Ops :( Algo deu errado !");
      }
    },
    async addAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const {
          plants: { plants },
        } = rootState;
        const { data } = await Plants.add(payload);
        this.setPlants([...plants, data]);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        return { success: false, message: "Erro ao adicionar planta." };
      }
      return { success: true, message: "Planta adicionada com sucesso." };
    },
    async updateAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const {
          plants: { plants },
        } = rootState;
        const { data } = await Plants.update(payload);
        const index = plants.findIndex(
          (plant) => plant.id === data.id
        );
        plants[index] = { ...plants[index], ...data };
        this.setPlants(plants);
        this.loading({ loading: false });
      } catch (error) {
        this.loading({ loading: false });
        if( error.response.status === 403) {
          this.setError(error.response.data);
          return { success: false, message: "Falha ao atualizar planta." };
        }
       return { success: false, message: "Erro ao atualizar planta." };
      }
      return { success: true, message: "Planta atualizada com sucesso." };
    },
    async deleteAsync(payload, rootState) {
      try {
        this.loading({ loading: true });
        const {
          plants: { plants },
        } = rootState;
        await Plants.delete(payload.id);
        this.setPlants(plants.filter((p) => p.id !== payload.id));
        this.loading({ loading: false });
      } catch (error) {
        this.setError(error.response.data)
        this.loading({ loading: false });
        return {
          success: false,
          loading: false,
          message: "Erro ao remover planta.",
        };
      }
      return {
        success: true,
        loading: false,
        message: "Planta removida com sucesso.",
      };
    },
    async findByDocumentNumberAsync(payload, rootState) {
      try {
        const { idLoadType, documentNumber } = payload;
        const { data } = await Plants.findByDocumentNumber(
          idLoadType,
          documentNumber
        );
        this.setPlants(data);
      } catch (error) {
        console.log(error);
        toast.error("Planta não encontrada ou indisponível para agendamento.");
      }
    },
    async clearPlantErrors (payload, rootState) {
      return this.setClearPlantErrors(payload, rootState);
    }
  }),
};
